import { INTEGRATIONS_EVENTS } from '../../constants/events';

export const reduxActionFormChange = (attributes) => ({
  type: INTEGRATIONS_EVENTS.FORM_CHANGE,
  payload: attributes
});

export const reduxActionAdAttributeChange = (attributes) => ({
  type: INTEGRATIONS_EVENTS.FORM_FIELD_CHANGE,
  payload: attributes
});

export const reduxActionIntegrationsFormOpen = () => ({
  type: INTEGRATIONS_EVENTS.FORM_OPEN,
  payload: {}
});

export const reduxActionIntegrationsFormClose = (attributes) => ({
  type: INTEGRATIONS_EVENTS.FORM_CLOSE,
  payload: attributes || {}
});

export const reduxActionIntegrationsFormSubmitted = () => ({
  type: INTEGRATIONS_EVENTS.FORM_SUBMITTED,
  payload: {}
});

export const reduxActionIntegrationsSetFormType = (type, source, globalState) => ({
  type: INTEGRATIONS_EVENTS.SET_FORM_TYPE,
  payload: { type, source, globalState }
});

export const reduxActionIntegrationsClearForm = () => ({
  type: INTEGRATIONS_EVENTS.CLEAR_FORM,
  payload: {}
});

export const reduxActionIntegrationsSourceClear = (source) => ({
  type: INTEGRATIONS_EVENTS.INTEGRATION_SOURCE_CLEAR,
  payload: { source }
});

export const reduxActionIntegrationUpdateFormState = (context) => ({
  type: 'UPDATE_FORM_STATE',
  payload: {context}
});



// WEBPACK FOOTER //
// ../q-jobs/src/actions/IntegrationsActions/index.js